import { GENDERED_LANGUAGES } from "@/common/language-groups";
import {
  LEVEL_BEGINNER,
  LEVEL_EXPERT,
  LEVEL_INTERMEDIATE,
  WEIGHTED_LEVELS
} from "@/common/level-types";

export const LEVELS = [LEVEL_BEGINNER, LEVEL_INTERMEDIATE, LEVEL_EXPERT];
export const LEVEL_DEFAULT = LEVEL_EXPERT;

/**
 * @param {string} level
 *
 * @returns {string|null}
 */
export function getNextLevel(level) {
  if (level === LEVEL_BEGINNER) {
    return LEVEL_INTERMEDIATE;
  }
  if (level === LEVEL_INTERMEDIATE) {
    return LEVEL_EXPERT;
  }
  return null;
}

/**
 * @param {string[]} levels
 *
 * @returns {string}
 */
export function getLowestLevel(levels) {
  levels.sort((levelA, levelB) => WEIGHTED_LEVELS[levelA] - WEIGHTED_LEVELS[levelB]);

  if (levels.length > 0) {
    return levels[0];
  }

  return LEVEL_DEFAULT;
}

/**
 * @param {string} level
 * @param {string} language
 *
 * @returns {Object.<string, string>|undefined}
 */

function getGenderMapByLevel(level, language) {
  if (!GENDERED_LANGUAGES.includes(language)) {
    return;
  }

  // Map the proper articles for each gender in the given language
  // Intended for beginner level French, German and Spanish
  // Keys are the (translated) genders directly from the backend
  const languageArticleMap = {
    french: {
      hankøn: "le",
      hunkøn: "la"
    },
    german: {
      hankøn: "der",
      hunkøn: "die",
      intetkøn: "das"
    },
    spanish: {
      hankøn: "el",
      hunkøn: "la"
    }
  };

  const levelGenderMap = {
    [LEVEL_BEGINNER]: languageArticleMap[language],
    [LEVEL_INTERMEDIATE]: {
      hankøn: "hankøn (m)",
      hunkøn: "hunkøn (f)",
      intetkøn: "intetkøn (n)"
    },
    [LEVEL_EXPERT]: {
      hankøn: "maskulinum",
      hunkøn: "femininum",
      intetkøn: "neutrum"
    }
  };

  return levelGenderMap[level];
}

/**
 * @param {string[]} genders
 * @param {string} level
 * @param {string} language
 *
 * @returns {string[]}
 */
export function mapGendersByLevel(genders, level, language) {
  const genderMap = getGenderMapByLevel(level, language);
  if (!genderMap) {
    return genders;
  }

  return genders.map((val) => genderMap[val] ?? val);
}
